import Login from '../components/Login';
import Home from '../components/Home';
import AdminBanner from '../components/AdminBanner';
import AdminCommunicated from '../components/AdminCommunicated';
import AdminContracts from '../components/AdminContracts';
import ConductAndEthics from '../components/ConductAndEthics';
import MoreManServ from '../components/MoreManServ';
import InstitutionalPresentation from '../components/InstitutionalPresentation';
import BirthDay from '../components/BirthDay';
import AdminPermissions from '../components/AdminPermissions';
import AdminManagement from '../components/AdminManagement';
import ManageCommunicated from '../components/ManageCommunicated';
import ManageTemplate from '../components/ManageTemplate';
import FavoritesApp from '../components/FavoritesApp';
import PageNotFound from '../components/PageNotFound';
import EthicRedirect from '../components/EthicRedirect';
import MoreRedirect from '../components/MoreRedirect';
import AdminSecureText from '../components/AdminSecureText';  

import { faHome, faBullhorn, faImages, faFileSignature, faUsers, faCog, faStar, faSpellCheck } from '@fortawesome/free-solid-svg-icons';

const mainRoutes = [
  {
    path: '/',
    component: Login,
    hideHeader: true,
  },
  {
    path: '/login',
    component: Login,
    hideHeader: true,
  },
  {
    path: '/404',
    component: PageNotFound,
  },
  {
    path: '/home',
    component: Home,
    label: 'Home',
    icon: faHome,
  },
  {
    path: '/admin/gestao_de_banners',
    label: 'Gestão de Banners',
    icon: faImages,
    component: AdminBanner,
    isAdm: true,
  },
  {
    path: '/admin/gestao_de_comunicados',
    label: 'Gestão de Comunicados',
    icon: faBullhorn,
    component: AdminCommunicated,
    isAdm: true,
  },
  {
    path: '/admin/gestao_de_Comunicados/comunicado/:id?/:edit?',
    component: ManageCommunicated,
    isAdm: true,
  },
  {
    path: '/admin/gestao_de_Comunicados/modelos',
    component: ManageTemplate,
    isAdm: true,
  },
  {
    path: '/admin/gestao_de_Contratos',
    label: 'Gestão de Contratos',
    icon: faFileSignature,
    component: AdminContracts,
    isAdm: true,
  },
  {
    path: '/admin/gerenciamento_de_permissoes',
    label: 'Gerenciamento de Permissões',
    icon: faUsers,
    component: AdminPermissions,
    isAdm: true,
  },
  {
    path: '/admin/painel_administrativa',
    show: true,
    label: 'Painel Administrativo',
    icon: faCog,
    component: AdminManagement,
    isAdm: true,
  },
  {
    path: '/codigo_de_conduta_e_etica',
    component: ConductAndEthics,
  },
  {
    path: '/mais_manserv',
    component: MoreManServ,
  },
  {
    path: '/apresentacao_institucional',
    component: InstitutionalPresentation,
  },
  {
    path: '/aniversarios',
    component: BirthDay,
  },
  {
    path: '/apps_favoritos',
    component: FavoritesApp,
    label: 'Aplicativos Favoritos',
    icon: faStar,
  },
  {
    path: '/eticaRedirect',
    component: EthicRedirect,
  },
  {
    path: '/maisRedirect',
    component: MoreRedirect,
  },
  {
    path: '/admin/gerenciamento_de_textos',
    label: 'Gerenciamento de Textos',
    icon: faSpellCheck,
    component: AdminSecureText,
    isAdm: true,
  }
];

export { mainRoutes };
